import { render, staticRenderFns } from "./AssignmentCreateFooter.vue?vue&type=template&id=7c65c072&scoped=true&"
import script from "./AssignmentCreateFooter.vue?vue&type=script&lang=js&"
export * from "./AssignmentCreateFooter.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCreateFooter.vue?vue&type=style&index=0&id=7c65c072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65c072",
  null
  
)

export default component.exports